var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.purposes,"label":_vm.$t('crudMyBookings.hReason'),"prepend-icon":"mdi-account","color":"grey","clearable":""},on:{"input":_vm.onInput},model:{value:(_vm.purpose),callback:function ($$v) {_vm.purpose=$$v},expression:"purpose"}})
}
var staticRenderFns = []

export { render, staticRenderFns }